import { LightningElement, api } from "lwc";

export default class PrimitiveTextInput extends LightningElement {
  @api placeholder;
}
